import {
  LinkInBioSocialService,
  SocialService,
} from "@drpcrd/shared/db/schema";
import {
  CameoLogo,
  EventbriteLogo,
  InstagramLogo,
  TikTokLogo,
  TwitchLogo,
  YouTubeLogo,
} from "@drpcrd/shared/ui";
import { Link } from "lucide-react";

type Props = {
  service: LinkInBioSocialService | SocialService;
  size?: number;
  className?: string;
};

/**
 * Renders the appropriate social media icon based on the provided service
 */
export const SocialIcon = ({
  service,
  size,
  className = "min-w-2.5",
}: Props) => {
  switch (service) {
    case "instagram":
      return (
        <InstagramLogo
          height={size}
          width={size}
          aria-label="Instagram icon"
          className={className}
        />
      );
    case "tiktok":
      return (
        <TikTokLogo
          height={size}
          width={size}
          aria-label="TikTok icon"
          className={className}
        />
      );
    case "twitch":
      return (
        <TwitchLogo
          height={size}
          width={size}
          aria-label="Twitch icon"
          className={className}
        />
      );
    case "youtube":
      return (
        <YouTubeLogo
          height={size}
          width={size}
          aria-label="YouTube icon"
          className={className}
        />
      );
    case "cameo":
      return (
        <CameoLogo
          height={size}
          width={size}
          aria-label="Cameo icon"
          className={className}
        />
      );
    case "eventbrite":
      return (
        <EventbriteLogo
          height={size}
          width={size}
          aria-label="Eventbrite icon"
          className={className}
        />
      );
    default:
      return <Link size={size} aria-label="Link icon" />;
  }
};
